import { Link } from './link';

export class SearchMatch {
    RecID: string;
    Name: string[] = [];
    Score: number;
    links: Link[] = [];

    constructor(data) {

        if (data.RecID) {
            this.RecID = data.RecID;
            this.Name = data.Name.split(',');
            this.Score = data.Score;
    
            data.Links.forEach(e => {
                this.links.push(new Link(e));
            });
        } else {
            this.RecID = data[0].id;
            this.Name = data[0].FromParty.join(', ');
            this.Score = data[1];

            data[0].links.forEach(e => {
                this.links.push(new Link(e));
            });
        }

    }
}